import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUserAuthInfo } from 'redux/types';

export interface AuthState {
  accessToken: string | null;
  currentUser: TUserAuthInfo | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constants: any;
}

const initialAuthState: AuthState = {
  accessToken: null,
  currentUser: null,
  constants: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    setAuthData: (
      state,
      action: PayloadAction<{ accessToken: string; currentUser: TUserAuthInfo }>
    ) => {
      const { accessToken, currentUser } = action.payload;

      state.accessToken = accessToken;
      state.currentUser = currentUser;
    },
    clearAuthData: (state) => {
      state.accessToken = null;
      state.currentUser = null;
    },
    updateUserData: (state, action) => {
      state.currentUser = { ...state.currentUser, ...action.payload };
    },
    setAppConstants: (state, action) => {
      state.constants = action.payload;
    },
  },
});

const authReducer = authSlice.reducer;

export const { setAuthData, clearAuthData, updateUserData, setAppConstants } =
  authSlice.actions;

export default authReducer;
